"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggletip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));
var _flyout = require("../flyout");
var _tooltip = require("../tooltip");
var _ToggletipCloseButton = require("./components/ToggletipCloseButton");
const Toggletip = _ref => {
  let {
    children,
    isOpen,
    placement,
    targetRef,
    removeCloseButton,
    onCloseRequested,
    ...otherToggletipProps
  } = _ref;
  const {
    popperProps,
    ...otherProps
  } = otherToggletipProps;
  return /*#__PURE__*/_react.default.createElement(_tooltip.Tooltip, (0, _extends2.default)({}, otherProps, {
    isOpen: isOpen,
    placement: placement,
    role: "dialog",
    "aria-modal": "true"
    // This is set to true in the Tooltip so we need to set it back here.
    ,
    ignoreStackOrder: false,
    popperProps: {
      strategy: "fixed",
      ...popperProps
    }
  }), /*#__PURE__*/_react.default.createElement(_flyout.ClickAwayListener, {
    onClickAway: e => {
      // Weird thing here w/ ClickAwayListener where if you close, then try and
      // quickly (within 500ms) reopen the Toggletip, it won't open. This is because
      // when isOpen is set to false, the Tooltip underneath is still transitioning
      // out so the ClickAwayListener is still mounted.
      //
      // Until 500ms later when the transition stops, the ClickAwayListener will still
      // be listening for click events outside this Toggletip. So when you click the
      // Toggletip target again, the ClickAwayListener says "oh, you clicked outside
      // the Toggletip, I'm going to close it again".
      //
      // In other words: the target click immediately sets isOpen to true, then the
      // target click event bubbles up to the document, CLickAwayListener sees that,
      // and sets it back to false...
      //
      // So, we require the targetRef in here to ensure we can deterministically check
      // if the click was inside or outside the Toggletip AND its target.
      if (isOpen && targetRef.current && !targetRef.current.contains(e.target)) {
        onCloseRequested();
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_reactFocusLock.default
  // Turning this off when isOpen is false allows focus to move back to the target.
  , {
    disabled: !isOpen
    // We're going to add our own in useToggletip since this one doesn't work with
    // the close transition timing of the Tooltip.
    ,
    returnFocus: false
  }, !removeCloseButton && /*#__PURE__*/_react.default.createElement(_ToggletipCloseButton.ToggletipCloseButton, {
    onClick: () => {
      onCloseRequested();
    }
  }), children)));
};
exports.Toggletip = Toggletip;
//# sourceMappingURL=Toggletip.js.map